export default __webpack_public_path__ + "static/media/head01_th_sp.ca9c061e.png";